import React, { useState, useContext } from "react";
import "./landing-page.scss";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { useHistory, Link } from "react-router-dom";
import { FirebaseContext } from "../../firebase/FirebaseContext";

import StaticLayout from "./StaticLayout";
import { useSelector } from "react-redux";
import PromoImages from "../../components/PromoImages";

import { getIsAuthLoggedIn } from "../../store/selectors";
import { useRedirectToCertification } from '../../utils/redirect';

function JoinWaitlistModal({ onClose /** , onHaveInvitationCode */ }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const { api } = useContext(FirebaseContext);
  const [isLoading, setIsLoading] = useState(false);

  const onContinue = async () => {
    setIsLoading(true);
    if (name && email) {
      //continue
      try {
        await api.addToWaitlist({ name, email });
        onClose();
      } catch (e) {}
    }
    setIsLoading(false);
  };

  return (
    <div className="modal">
      <div className="modal-overlay">
        <div className="modal-body">
          <div className="modal-close" onClick={onClose}>
            <img src="/assets/images/cross.png" alt="cross" />
          </div>
          <div className="invitation-modal">
            <div className="text-title">Join the Waitlist</div>
            <div className="text-info mb-3">
              Stay up-to-date for the latest partnerships and opportunities
              offered through the ByBlack certification.
            </div>
            <div className="join-form">
              <div className="join-wishlist-input">
                <input
                  className="form-control"
                  placeholder="Name*"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="join-wishlist-input">
                <input
                  className="form-control"
                  placeholder="Email*"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <button
                className="btn btn-primary btn-lg mb-5"
                disabled={isLoading}
                onClick={onContinue}
              >
                Sign-up Today
              </button>

              {/* <a className="mb-2 have-invitation-code" onClick={onHaveInvitationCode}> I have an invitation code. </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function LandingPage() {
  useRedirectToCertification();

  const [showJoinWaitlistModal, setShowJoinWaitlistModal] = useState(false);

  const isLoggedIn = useSelector(getIsAuthLoggedIn);
  const history = useHistory();

  const onRegister = () => {
    history.push("/register");
  };

  return (
    <StaticLayout>
      <div className="block-section">
        <div className="block-section-half block-section-content bg-gray-4">
          <div className="content-row-contents">
            <PromoImages />
            <h1 className="heading">
              Become a certified Black-owned business.
            </h1>
            <div className="text-large">
              Take your business to the next level for free with the tools and
              resources that matter
            </div>
            {!isLoggedIn && (
              <div className="button-container">
                <button
                  onClick={onRegister}
                  className="button button-spacer w-button"
                >
                  Get Started
                </button>
                <button
                  onClick={() => setShowJoinWaitlistModal(true)}
                  className="button button-outline w-button"
                >
                  Sign-up for Newsletter
                </button>
              </div>
            )}
          </div>
          <div className="decoration-container">
            <div
              data-w-id="def833e6-9c5e-5df8-7515-b527e786d58c"
              className="decoration-circle bg-primary-3"
            />
          </div>
        </div>
        <div className="block-section-half">
          <img
            src="/assets/images/landing-page/image-9-copy.jpeg"
            srcSet="/assets/images/landing-page/image-9-copy-p-500.jpeg 500w, /assets/images/landing-page/image-9-copy.jpeg 795w"
            sizes="(max-width: 991px) 100vw, 50vw"
            alt=""
            className="block-section-image"
          />
        </div>
      </div>
      <div className="section call-out">
        <div className="container">
          <div className="section-title no-bottom-space">
            <div className="badge badge-title text-primary-2">
              <div className="badge-text">
                <Link to="/register" className="button w-button">
                  Get Certified
                </Link>
              </div>
              <div className="badge-bg bg-primary-2" />
            </div>
            <h2 className="heading-2">
              Powered by the US Black Chamber of Commerces
            </h2>
            <div
              className="text-large content-row-subtitle"
              style={{ textAlign: "center" }}
            >
              We leverage a network of over 140 Chambers across the country to
              vet and verify businesses that are Black-owned and deserve new
              opportunities for growth. We aren't just building a platform,
              we're empowering a community.
            </div>
            <Link to="/page/faq" className="button w-button">
              Learn More
            </Link>
          </div>
        </div>
      </div>
      <div className="section bg-gray-4">
        <div className="container">
          <div className="content-row align-center">
            <div
              data-w-id="fcfb1eb7-ad26-f467-f92a-3e277e55610f"
              className="content-row-contents"
            >
              <h3 className="medium-heading">
                Setting a new standard for what it means to be Black in business
              </h3>
              <p className="text-large">
                We've designed a certification program that is easy to navigate
                and only asks the important questions. Complete your application
                in less than 30 minutes, today.
              </p>
              <ul className="icon-list w-list-unstyled">
                <li className="icon-list-item icon-list-item-large">
                  <div className="check-circle bg-primary-2">
                    <img
                      src="/assets/images/landing-page/icon-check-small.svg"
                      alt=""
                      className="check-circle-icon"
                    />
                  </div>
                  <div className="text-block-2">
                    You'll need to provide proof of your ownership, control of
                    the business, and identity.
                  </div>
                </li>
                <li className="icon-list-item icon-list-item-large">
                  <div className="check-circle bg-primary-2">
                    <img
                      src="/assets/images/landing-page/icon-check-small.svg"
                      alt=""
                      className="check-circle-icon"
                    />
                  </div>
                  <div className="text-block-3">
                    Our team of chambers and local leaders will review all
                    applications thoroughly to assess your qualification.
                  </div>
                </li>
                <li className="icon-list-item icon-list-item-large">
                  <div className="check-circle bg-primary-2">
                    <img
                      src="/assets/images/landing-page/icon-check-small.svg"
                      alt=""
                      className="check-circle-icon"
                    />
                  </div>
                  <div className="text-block-4">
                    You will receive exclusive access to entrepreneurial
                    educational resources, industry events, and business
                    opportunities when you become a certified business.
                  </div>
                </li>
              </ul>
            </div>
            <div
              data-w-id="fcfb1eb7-ad26-f467-f92a-3e277e556122"
              className="content-row-image-wrapper"
            >
              <img
                src="/assets/images/landing-page/GettyImages-629567166.jpg"
                width={486}
                srcSet="/assets/images/landing-page/GettyImages-629567166-p-500.jpeg 500w, /assets/images/landing-page/GettyImages-629567166-p-800.jpeg 800w, /assets/images/landing-page/GettyImages-629567166-p-1080.jpeg 1080w, /assets/images/landing-page/GettyImages-629567166.jpg 1233w"
                sizes="(max-width: 479px) 100vw, 486px"
                alt=""
                className="content-row-image"
              />
              <div
                data-w-id="fcfb1eb7-ad26-f467-f92a-3e277e556124"
                className="decoration-circle content-row-image-circle bg-primary-3"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="section bg-gray-4">
        <div className="container">
          <div
            data-delay={4000}
            data-animation="slide"
            data-autoplay={1}
            data-nav-spacing={6}
            data-duration={500}
            data-infinite={1}
            className="testimonials-slider w-slider"
            style={{ height: "fit-content" }}
          >
            <div className="slider-mask w-slider-mask">
              <div className="w-slide">
                <div className="testimonial">
                  <div className="avatar-container">
                    <img
                      src="/assets/images/landing-page/review-1.jpg"
                      alt=""
                      className="avatar avatar-large"
                    />
                    <div className="testimonial-quote-symbol testimonial-quote-symbol-large text-primary-3">
                      “
                    </div>
                  </div>
                  <div className="small-heading testimonial-text">
                    “This was genuinely the smoothest process I’ve ever had in
                    trying to certify my business. I’m really impressed by this
                    experience. I can’t recommend it enough”
                  </div>
                  <div className="text-block-5">Farad A.</div>
                  <div className="text-block-6">
                    Certified Black Business-Owner
                  </div>
                </div>
              </div>
              <div className="w-slide">
                <div className="testimonial">
                  <div className="avatar-container">
                    <img
                      src="/assets/images/landing-page/review-2.jpg"
                      alt=""
                      className="avatar avatar-large"
                    />
                    <div className="testimonial-quote-symbol testimonial-quote-symbol-large text-primary-3">
                      “
                    </div>
                  </div>
                  <div className="small-heading testimonial-text">
                    “When ByBlack and the US Black Chambers originally said they
                    were going to build a certification portal I didn’t imagine
                    they’d have such a game-changing approach to solving the
                    issue of who is a Black owned-business”
                  </div>
                  <div className="text-block-5">Antwanye F.</div>
                  <div className="text-block-6">
                    Local Chamber of Commerce President
                  </div>
                </div>
              </div>
              <div className="w-slide">
                <div className="testimonial">
                  <div className="avatar-container">
                    <img
                      src="/landing-page/images/avatar-woman.png"
                      alt=""
                      className="avatar avatar-large"
                    />
                    <div className="testimonial-quote-symbol testimonial-quote-symbol-large text-primary-3">
                      “
                    </div>
                  </div>
                  <div className="small-heading testimonial-text">
                    “We are excited about how this solution is helping us evolve
                    our supplier diversity conversations and reach new
                    Black-owned businesses.”
                  </div>
                  <div className="text-block-5">Veronica R.</div>
                  <div className="text-block-6">
                    Corporate Partner & Supplier Diversity Expert
                  </div>
                </div>
              </div>
            </div>
            <div className="hide-slide-arrow w-slider-arrow-left">
              <div className="w-icon-slider-left" />
            </div>
            <div className="hide-slide-arrow w-slider-arrow-right">
              <div className="w-icon-slider-right" />
            </div>
            <div className="testimonial-slide-nav w-slider-nav w-slider-nav-invert w-round" />
          </div>
        </div>
      </div>
      {/* <div className="section bg-primary" id="faq">
        <div className="container">
          <div className="section-title">
            <div className="badge badge-title text-white">
              <div className="badge-text">Questions</div>
              <div className="badge-bg bg-white">sad</div>
            </div>
            <h2 className="text-white">You probably have questions.</h2>
            <div className="text-large text-white">These are the most frequently asked questions about the certification.</div>
          </div>
            <Collapsible />
        </div>
      </div> */}
      <div className="section-large">
        <div className="container">
          <div className="cta-container">
            <h3 className="medium-heading">Have more questions?</h3>
            <p className="text-large content-row-subtitle">
              You can reach out to our team to learn more here.
            </p>
            <div className="cta-action-container">
              <a
                href="mailto:certification@byblack.us"
                className="button w-button"
              >
                Get in touch
              </a>
            </div>
          </div>
        </div>
        <div className="decoration-container left">
          <div className="decoration-circle bg-primary-3" />
        </div>
      </div>
      {showJoinWaitlistModal && (
        <JoinWaitlistModal
          onClose={() => setShowJoinWaitlistModal(false)}
          onHaveInvitationCode={() => {
            setShowJoinWaitlistModal(false);
          }}
        />
      )}
    </StaticLayout>
  );
}
